// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"BackgroundModal_modal_wrapper__tBcM9","modal_title":"BackgroundModal_modal_title__VjY2x","modal_text":"BackgroundModal_modal_text__aQcIg"};